import {Box, Button, styled} from "@mui/material";
import {buildPath, scale} from "../../../utils";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import React, {ReactNode} from "react";
import Text from "../../text";
import {useLocation, useNavigate} from "react-router-dom";
import LABEL from "../../../resources/label";
import theme, {FONTS} from "../../../constants/theme";
import {useMediaQuery} from "@mui/system";

interface Props {
  children?: Array<ReactNode>;
  mobileStep?: 1 | 2 | 3;
  setMobileStep?: (mobileStep: 1 | 2 | 3) => void;
}

const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: scale(13),
  alignSelf: 'flex-start',
  marginBottom: scale(12),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: '#0173C6',
    borderTop: '8px solid #1976d2',
    borderBottom: '8px solid #1976d2',
    marginTop: 0,
  },
});

const NavigationGroup = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: scale(20),
  height: scale(35),
  marginLeft: scale(20),
});

const NavigationButton = styled(Button)({
  backgroundColor: '#0173C6',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  borderRadius: '50%',
  minWidth: scale(35),
  width: scale(35),
  height: scale(35),
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'white',
  },

})

const ChildrenGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignSelf: 'center',
  gap: scale(40),
  marginRight: scale(30),
});

const BaseHeader = ({children, mobileStep, setMobileStep}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleBack = () => {
    const regex = /\/operatore\/dettaglio-raccolta\/[^/]+$/;
    const regex2 = /\/operatore\/crea-raccolta$/;
    const regex3 = /\/operatore\/dettaglio-raccolta\/[^/]+\/aggiungi-donatore(\/.*)?$/;
    const regex4 = /\/donatore\/raccolta\/[^/]+$/;
    if (regex.test(location.pathname) || regex2.test(location.pathname)) {
      if (regex2.test(location.pathname)) {
        sessionStorage.removeItem('createDonation');
      }
      navigate(buildPath("/operatore/calendario"));
    } else if (regex4.test(location.pathname)) {
      if (setMobileStep && mobileStep) {
        if (mobileStep === 2 || mobileStep === 3) {
          switch (mobileStep) {
            case 2: setMobileStep(1); break;
            case 3: setMobileStep(2); break;
          }
          return;
        } else {
          navigate(buildPath("/donatore/calendario"));
        }
      } else {
        navigate(buildPath("/donatore/calendario"));
      }
    } else {
      if (regex3.test(location.pathname)) {
        sessionStorage.removeItem('newDonorInfo');
      } else if (setMobileStep && mobileStep) {
        if (mobileStep === 2 || mobileStep === 3) {
          switch (mobileStep) {
            case 2: setMobileStep(1); break;
            case 3: setMobileStep(2); break;
          }
          return;
        } else {
          navigate(-1);
        }
      }
      navigate(-1);
    }
  };

  return (
    <Wrapper>
      <NavigationGroup>
        <NavigationButton onClick={handleBack}>
          <NavigateBeforeIcon
            color={isMobile ? 'primary' : 'white'}
            sx={{
              fontSize: scale(42),
              marginRight: '1px',
            }}
          />
        </NavigationButton>
        <Text
          text={LABEL.GO_BACK}
          color={isMobile ? theme.palette.text.primary : theme.palette.text.secondary}
          fontFamily={FONTS.MONTSERRAT}
          fontWeight={'bold'}
          fontSize={scale(24)}
          sx={{textTransform: 'uppercase'}}
        />
      </NavigationGroup>
      {children && (
        <ChildrenGroup>
          {children}
        </ChildrenGroup>
      )}
    </Wrapper>
  );
}

export default BaseHeader;
